<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5 d-flex" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <template v-if="!gestaoDeAula.is_polivalencia"> </template>
            <template v-else>
              <h4>Componentes Curriculares:</h4>
              <div class="container">
                <div class="row">
                  <div v-for="(item, index) in gestaoDeAula.disciplinas" :key="index">
                    <v-chip class="ml-2" x-small>{{ item.descricao }} </v-chip>
                  </div>
                </div>
              </div>
            </template>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-if="etapas" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="6" v-if="etapas?.length">
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <e-label>Etapas</e-label>

              <e-autocomplete
                v-if="editing"
                disabled
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item.descricao} - Início: ${dateFormatConvert(
                      item.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item.id"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
              />

              <e-autocomplete
                v-else
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item.descricao} - Início: ${dateFormatConvert(
                      item.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item.id"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col>
            <v-btn
              v-if="etapaBloqueada == true && etapaPendente == false"
              style="box-shadow: none"
              color="success"
              class="text-none mt-4"
              @click="() => criarPedido(etapaSelecionada)"
              >Solicitar Autorização</v-btn
            >
          </v-col>
        </v-row>
        <div v-if="etapaSelecionada && etapaBloqueada == false">
          <v-row>
            <v-col class="pt-0 pb-0" cols="6">
              <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                <e-label>Tipo de Aula</e-label>
                <e-autocomplete
                  :items="$constants.tiposDeAulas"
                  :return-object="false"
                  :error-messages="errors"
                  v-model="aulaSelecionada.tipo_de_aula"
                  @change="() => verificaTipoDaAula()"
                  label="Selecione um tipo de aula"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col class="pt-0 pb-0" cols="6">
              <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                <e-label>Selecione uma data</e-label>
                <e-date-picker-calendario-letivo
                  v-model="aulaSelecionada.data"
                  :gestao-de-aula="gestaoDeAula"
                  :inicio-periodo-etapa="inicioPeriodoEtapa"
                  :fim-periodo-etapa="fimPeriodoEtapa"
                  :disabled="!aulaSelecionada.tipo_de_aula"
                  :editing="editing"
                  :error-messages="errors"
                  label="Escolha uma data"
                  @horarios-changed="onHorariosChanged"
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12">
              <div cols="12" v-if="!editing">
                <div v-if="gestaoDeAula.is_polivalencia">
                  <e-label>Selecione os Componentes Curriculares dessa Aula:</e-label>
                  <div class="container">
                    <div class="row">
                      <v-checkbox
                        class="ml-2"
                        v-for="(item, index) in gestaoDeAula.disciplinas"
                        :key="index"
                        v-model="disciplinasMarcadas"
                        :label="item.descricao"
                        :value="item.id"
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <v-col cols="12" v-else>
                <div v-if="aulaSelecionada.disciplinas?.length">
                  <div class="row mb-2">
                    <e-label>Componentes Curriculares dessa Aula</e-label>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div v-for="(item, index) in aulaSelecionada.disciplinas" :key="index">
                        <v-chip x-small>{{ getNomeDisciplina(item) }} </v-chip>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
              <template v-if="!gestaoDeAula.is_polivalencia">
                <e-label>Conteúdo</e-label>
                <v-textarea solo dense v-model="aulaSelecionada.conteudo" />
              </template>

              <template v-else>
                <div v-if="!editing">
                  <e-label>Conteúdos</e-label>
                  <v-card v-for="item in arrayConteudos" :key="item" class="mx-auto my-1 col-12">
                    <strong>
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                      Conteudo de {{ item.descricao }}:
                    </strong>
                    <v-textarea solo dense v-model="conteudos[item.id]" />
                    <strong>
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      Horário de {{ item.descricao }}:
                    </strong>
                    <v-alert v-if="!aulaSelecionada.data" text="..." type="warning" variant="tonal"
                      >Selecione uma data para listar os horários.</v-alert
                    >
                    <ValidationProvider name="Horário" rules="required" v-slot="{ errors }">
                      <e-autocomplete
                        :disabled="aulaSelecionada.data ? false : true"
                        :items="horarios"
                        multiple
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarios_selecionados_extras[item.id]"
                        return-object
                        dense
                        :error-messages="errors"
                        @change="
                          ($event) => {
                            verifyHorariosSelectExtra($event, item.id);
                          }
                        "
                      />
                    </ValidationProvider>
                  </v-card>
                </div>
                <div
                  v-else-if="editing && JSON.parse(aulaSelecionada?.horarios_extras).length >= 0"
                >
                  <e-label>Conteúdos</e-label>
                  <v-card
                    v-for="(item, index) in arrayConteudos"
                    :key="index"
                    class="mx-auto my-1 col-12"
                  >
                    <strong>{{ getNomeDisciplina(item.id) }}</strong>
                    <v-textarea
                      solo
                      dense
                      :value="item.content"
                      @change="editarConteudoPoli(index, $event)"
                    />

                    <div>
                      <div class="mb-5">
                        <ul v-if="horariosDefinidos.find((x) => x.id === item.id)?.array">
                          <div
                            v-for="(item, ind) in horariosDefinidos.find((x) => x.id === item.id)
                              ?.array"
                            :key="ind"
                          >
                            <li>{{ getObjHorario(item) }}</li>
                          </div>
                        </ul>
                        <v-btn @click="editarHorario = index">Alterar Horário</v-btn>
                      </div>
                    </div>

                    <template v-if="editarHorario === index">
                      <e-autocomplete
                        :disabled="aulaSelecionada.data ? false : true"
                        :items="horarios"
                        multiple
                        label="Selecione"
                        :item-text="(item) => item.descricao"
                        v-model="horarios_selecionados_extras[item.id]"
                        return-object
                        dense
                        @change="
                          ($event) => {
                            verifyHorariosSelectExtra($event, item.id);
                          }
                        "
                      />
                    </template>
                  </v-card>
                </div>
              </template>

              <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
                <e-label>Metodologia</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.metodologia"
                  :error-messages="errors"
                />
              </ValidationProvider>

              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn
                v-if="editing && outrosCampos"
                class="ml-3"
                color="success"
                @click="dialog.duplicar = true"
                >Duplicar Aula</v-btn
              >
              <v-btn
                v-if="editing && outrosCampos"
                class="ml-3"
                color="success"
                @click="dialog.exportar = true"
                >Exportar Aula</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <v-row v-if="etapas?.length === 0 && etapaBloqueada == false">
          <v-col cols="12">
            <v-alert type="warning" border="left">
              Não existem etapas disponíveis para a data atual
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaBloqueada == true && etapaPendente == false">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Atenção essa etapa está bloqueada, para lançar aulas você deve solicitar uma
              autorização, clicando no botão acima
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaPendente == true">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Aguarde, já existe um pedido de autorização para essa etapa e estamos analisando.
            </v-alert>
            <v-btn class="success" @click="verPedidos">Acompanhe seus pedidos</v-btn>
          </v-col>
        </v-row>

        <div v-if="etapas?.length > 0 && etapaBloqueada == false && etapaSelecionada">
          <v-row v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data">
            <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
              <v-alert type="warning" border="left"> Por favor, preencha todos os campos! </v-alert>
            </v-col>
          </v-row>
        </div>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable persistent>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <h2 class="mt-4">Horário em Conflito com aulas já cadastradas!</h2>
          <h2 class="mt-4 mb-2">{{ horarioComConflito?.descricao }}</h2>
          <div v-if="aulasConflitadas.length" class="mb-4">
            <p class="mb-1">O professor já possui aula nesse dia e horário em:</p>
            <v-chip v-for="item in aulasConflitadas" :key="item.id" class="ma-1" small>
              {{ item.turma?.descricao }}
            </v-chip>
          </div>
          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Resolver Conflito
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <v-alert
      text
      border="left"
      color="orange"
      icon="warning"
      class="custom-orange-alert text-body-1"
      v-else
    >
      <span class="alert-text-black">
        Atenção, essa turma ainda não foi vinculada a um circuito, para fazer isso você tem que ir
        em Turmas->Editar e Selecione o Circuito desejado, caso seja um professor aguarde o
        responsável realizar esse procedimento.
      </span>
    </v-alert>
    <e-modal-duplicar-aula-polivalencia
      v-if="aulaSelecionada.disciplinas"
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :horarios="horarios"
      :disciplinas="aulaSelecionada.disciplinas"
      :etapa="etapaSelecionada"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula-polivalencia>
    <e-modal-duplicar-aula
      v-else
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :horarios="horarios"
      :etapa="etapaSelecionada"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <e-modal-exportar-aula-polivalencia
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      :etapa="etapaSelecionada"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula-polivalencia>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";
import { dateFormatParam } from "../../plugins/filters";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
  },
  async mounted() {
    await this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
  },
  data() {
    return {
      horarioComConflito: null,
      array_horarios_extras: [],
      horarios_selecionados_extras: [],
      conteudos: [],
      arrayConteudos: [],
      disciplinasMarcadas: [],
      avisoAnime: "",
      etapaPendente: false,
      etapaBloqueada: false,
      idsEtapasDisponivels: [],
      idsEtapasPendentes: [],
      fimPeriodoEtapa: null,
      inicioPeriodoEtapa: null,
      etapaSelecionada: null,
      etapas: null,
      turma: null,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      mostrarCampos: false,
      outrosCampos: false,
      submittingForm: false,
      aulaSelecionada: {
        data: null,
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      arrayConteudoEditar: [],
      editarHorario: null,
      horariosDefinidos: [],
    };
  },
  watch: {
    disciplinasMarcadas(val) {
      const arrayConvert = [];
      val.forEach((element) => {
        const valor = this.gestaoDeAula.disciplinas.filter((dado) => dado.id === element);
        arrayConvert.push(valor[0]);
      });
      this.atualizarTopicos(arrayConvert);
    },
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
      }
    },
  },
  methods: {
    onHorariosChanged(horarios) {
      this.horarios = horarios;

      // Se estiver editando e o horário selecionado existir, mantê-lo
      if (this.editing && this.horarioSelecionado) {
        const horarioExists = horarios.some((h) => h.id === this.horarioSelecionado.id);
        if (!horarioExists && this.horarioSelecionado.id) {
          horarios.push(this.horarioSelecionado);
        }
      }
    },

    async verificarHorariosDaDataCarregada() {
      // Converter data DD/MM/YYYY para YYYY-MM-DD
      if (!this.aulaSelecionada.data) return;

      const parts = this.aulaSelecionada.data.split("/");
      if (parts.length !== 3) return;

      const dataYMD = `${parts[2]}-${parts[1]}-${parts[0]}`;
      const diaDaSemana = new Date(dataYMD).getDay();

      // Carregar eventos do calendário letivo
      const response = await this.$services.calendarioLetivoService.syncAll();
      const todosEventos = response.map((evento) => ({
        data: evento.start,
        descricao: evento.descricao,
        cor: evento.color,
        is_feriado: evento.evento.is_feriado,
        is_sabado_letivo: evento.evento.is_sabado_letivo,
      }));

      // Verificar se a data é um evento
      const evento = todosEventos.find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === dataYMD;
      });

      // Se for sábado letivo, carregar TODOS os horários
      if (evento && (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1)) {
        const responseHorarios = await this.$services.gestoesDeAulasService.getAllHorarios();
        const todosHorarios = responseHorarios.data || responseHorarios;

        this.horarios = todosHorarios;

        // Garantir que o horário selecionado está na lista
        if (this.horarioSelecionado) {
          const horarioExists = this.horarios.some((h) => h.id === this.horarioSelecionado.id);
          if (!horarioExists) {
            this.horarios.push(this.horarioSelecionado);
          }
        }
      } else if (this.gestaoDeAula?.relacoesDiasHorarios) {
        // Se não for sábado letivo, usar horários do dia da semana
        const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
          .filter((relacao) => relacao.dia.id === diaDaSemana)
          .map((relacao) => relacao.horario);

        this.horarios = horariosDoDia;

        // Se o horário selecionado não estiver na lista de horários permitidos,
        // não adicionar (deixar aparecer "Horário não encontrado")
      }
    },

    getHorariosDaAula(aula) {
      return JSON.parse(aula?.horarios_extras);
    },

    verifyHorariosSelectExtra(item, IDdisciplina) {
      let disciplina = this.array_horarios_extras.find((it) => it.id === IDdisciplina);

      if (!disciplina) {
        disciplina = {
          id: IDdisciplina,
          array: [],
        };
        this.array_horarios_extras.push(disciplina);
      } else {
        disciplina.array = [];
      }

      const horariosDosOutrosCampos = this.array_horarios_extras
        .filter((it) => it.id !== IDdisciplina)
        .flatMap((it) => it.array);

      item.forEach((element) => {
        if (horariosDosOutrosCampos.includes(element.id)) {
          this.$toast.warn("Esse horário está sendo usado, escolha outro!");

          if (this.horarios_selecionados_extras[IDdisciplina]) {
            this.horarios_selecionados_extras[IDdisciplina] = this.horarios_selecionados_extras[
              IDdisciplina
            ].filter((it) => it.id !== element.id);
          }
        } else {
          disciplina.array.push(element.id);
          this.pesquisaAulas(element.id, IDdisciplina);
        }
      });
    },

    getNomeDisciplina(id) {
      const dis = this.gestaoDeAula.disciplinas.filter((obj) => obj.id === id);
      return dis[0].descricao;
    },
    getObjHorario(id) {
      if (id) {
        const dis = this.horarios.filter((obj) => obj.id === id);
        return dis[0]?.descricao || "Horário não encontrado";
      }
    },
    editarConteudoPoli(index, $event) {
      this.arrayConteudos[index] = $event;
    },
    getConteudoPolivalencia() {
      if (!this.aulaSelecionada.disciplinas || !Array.isArray(this.aulaSelecionada.disciplinas)) {
        this.arrayConteudoEditar = [];
        return;
      }

      this.aulaSelecionada.disciplinas.forEach((element, index) => {
        const conteudoPolivalencia = JSON.parse(this.aulaSelecionada.conteudo_polivalencia || "[]");
        this.arrayConteudoEditar.push(conteudoPolivalencia[index]);
      });

      this.arrayConteudoEditar.forEach((element, index) => {
        const obj = {
          id: this.aulaSelecionada.disciplinas[index],
          content: element,
        };
        this.arrayConteudos.push(obj);
      });
    },
    atualizarTopicos(array) {
      this.arrayConteudos = [];
      array.forEach((element) => {
        this.arrayConteudos.push(element);
      });
    },
    animarAviso() {
      this.avisoAnime = "animate__animated animate__headShake";
      setTimeout(() => (this.avisoAnime = ""), 500);
    },
    dateFormatConvert(data) {
      return dateFormatParam(data);
    },
    verificarEtapaSelecionada() {
      this.aulaSelecionada.data = null;
      this.horariosDefinidos = null;
      // this.horarios = null;
      // this.array_horarios_extras = null;

      this.animarAviso();
      this.inicioPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada)
        .shift().periodo_inicial;
      this.inicioPeriodoEtapa = dateFormatParam(this.inicioPeriodoEtapa, "y-m-d");
      this.fimPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada)
        .shift().periodo_final;
      this.fimPeriodoEtapa = dateFormatParam(this.fimPeriodoEtapa, "y-m-d");

      const etapaVerificar = this.etapas.filter((d) => d.id === this.etapaSelecionada).shift();

      this.verificarSeEtapaEstaDisp(etapaVerificar);
    },
    async pesquisaAulas(horarioId, disciplinaId) {
      const data_aula = this.aulaSelecionada.data;
      const { aula_id } = this.$route.params;
      const turma_id = this.gestaoDeAula.turma.id;
      if (!data_aula || !horarioId || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitosPoli(
        data_aula,
        horarioId,
        turma_id,
        aula_id,
        this.gestaoDeAula.instrutor_id
      );

      if (response.data?.tem_conflito) {
        this.horarioComConflito = this.horarios.filter((item) => item.id === horarioId).shift();
        this.aulasConflitadas = response.data.aulas_conflitadas ?? [];

        this.removerHorarioConflitante(horarioId, disciplinaId);

        this.aulasEmConflitos = true;
      }
    },

    removerHorarioConflitante(horarioId, disciplinaId) {
      if (this.horarios_selecionados_extras[disciplinaId]) {
        this.$set(
          this.horarios_selecionados_extras,
          disciplinaId,
          this.horarios_selecionados_extras[disciplinaId].filter((item) => item.id !== horarioId)
        );
      }

      const disciplina = this.array_horarios_extras.find((item) => item.id === disciplinaId);
      if (disciplina) {
        disciplina.array = disciplina.array.filter((id) => id !== horarioId);
      }
    },
    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      this.mostrarCampos = true;
      this.outrosCampos = false;
    },
    async editarHorarioIndividual(index, obj) {
      const horariosAula = JSON.parse(this.aulaSelecionada?.horarios);
      horariosAula[index] = obj.id;
      this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
      this.aulaSelecionada.horarios = JSON.stringify(horariosAula);

      await this.$services.aulasService.atualizar(this.aulaSelecionada);
      this.$toast.success("Horário editado com sucesso!");
      this.loadData();
      this.editarHorario = null;
    },
    // Revalida todos os horários escolhidos no envio, já que a data pode ter mudado depois
    async existeConflitoDeHorario() {
      if (!this.aulaSelecionada.data || !this.array_horarios_extras?.length) return false;

      const verificacoes = this.array_horarios_extras.flatMap((disciplina) =>
        (disciplina.array ?? []).map((horarioId) => ({ horarioId, disciplinaId: disciplina.id }))
      );

      this.aulasEmConflitos = false;

      // Sequencial de propósito: a primeira colisão já interrompe o envio
      // eslint-disable-next-line no-restricted-syntax
      for (const { horarioId, disciplinaId } of verificacoes) {
        // eslint-disable-next-line no-await-in-loop
        await this.pesquisaAulas(horarioId, disciplinaId);
        if (this.aulasEmConflitos) return true;
      }

      return false;
    },

    async submitForm() {
      if (await this.existeConflitoDeHorario()) {
        this.$toast.danger("Já existe aula lançada para esse dia e horário.");
        return;
      }

      if (this.editing) {
        // conteudos
        const arrayParaEditar = this.arrayConteudos;
        arrayParaEditar.forEach((element, index) => {
          if (typeof element !== "string") {
            arrayParaEditar[index] = element.content;
          }
        });
        this.aulaSelecionada.conteudo_polivalencia = JSON.stringify(arrayParaEditar);

        this.aulaSelecionada.horarios_extras = JSON.stringify(this.array_horarios_extras);
      } else {
        if (this.conteudos.some((elemento) => elemento !== null)) {
          const arr = [];
          this.disciplinasMarcadas.forEach((element) => {
            arr.push(this.conteudos[element]);
          });

          this.aulaSelecionada.conteudo_polivalencia = JSON.stringify(arr);

          // Na polivalência os horários vão em horarios_extras, um conjunto por componente
          this.aulaSelecionada.horarios = JSON.stringify([]);
          this.aulaSelecionada.horarios_extras = JSON.stringify(this.array_horarios_extras);
        }

        this.aulaSelecionada.disciplinas = this.disciplinasMarcadas;
        this.aulaSelecionada.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
        this.aulaSelecionada.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
      }

      this.aulaSelecionada.horario_inicial = this.horarioSelecionado
        ? this.horarioSelecionado.inicio
        : null;
      this.aulaSelecionada.horario_final = this.horarioSelecionado
        ? this.horarioSelecionado.final
        : null;
      this.aulaSelecionada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
      this.aulaSelecionada.etapa_id = this.etapaSelecionada;

      this.submittingForm = true;
      try {
        if (this.editing) {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          this.aulaSelecionada.etapa_id = this.aulaSelecionada.etapa_id.id;
          await this.$services.aulasService.atualizar(this.aulaSelecionada);
          this.$toast.success("Aula editada com sucesso!");
          this.$router.back();
        } else {
          if (!this.aulaSelecionada.conteudo_polivalencia) {
            this.$toast.warn("Adicione pelo menos algum campo de conteúdo!");
            this.submittingForm = false;
            return;
          }

          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.disciplina_id = this.gestaoDeAula.disciplina_id;
          this.aulaSelecionada.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
          this.aulaSelecionada.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.criar(this.aulaSelecionada);
          this.$toast.success("Aula cadastrada com sucesso!");
          this.$router.back();
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
      }
    },
    async getAula() {
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );
      this.turma = response.payload.gestaoDeAula.turma;
      this.gestaoDeAula = response.payload.gestaoDeAula;
      this.horarios = response.payload.horarios.filter((horario) => horario.descricao);

      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));
      this.horarioSelecionado = aulaSelecionada.horario ?? null;
      this.aulaSelecionada.data = aulaSelecionada.data;

      if (this.gestaoDeAula.relacoesDiasHorarios) {
        this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
      }
      return aulaSelecionada;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        this.aulaSelecionada = await this.getAula();

        if (!this.aulaSelecionada.disciplinas) {
          this.aulaSelecionada.disciplinas = [];
        }

        if (this.turma.circuito_nota_id) {
          const response = await this.$services.etapasService.syncAllEtapasDisponiveis(
            this.turma.circuito_nota_id,
            this.$route.params.gestaoDeAulaId
          );
          this.etapas = response.etapas;
          this.idsEtapasDisponivels = response.disponiveis;

          this.etapas.forEach((element) => {
            this.verificarSeTemPedido(element.id);
          });

          if (this.editing) {
            this.getEtapa();
            this.horariosDefinidos = this.getHorariosDaAula(this.aulaSelecionada);
          }
        }
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }
        this.$forceUpdate();

        if (this.editing) {
          this.getConteudoPolivalencia();
          this.array_horarios_extras = JSON.parse(this.aulaSelecionada.horarios_extras);

          // Verificar horários corretos para a data selecionada (sábado letivo, etc)
          await this.verificarHorariosDaDataCarregada();
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    getEtapa() {
      let etapa = this.etapas.filter((d) => d.id === this.aulaSelecionada.etapa_id);
      etapa = etapa.shift();
      this.fimPeriodoEtapa = etapa.periodo_final;
      this.inicioPeriodoEtapa = etapa.periodo_inicial;
      this.etapaSelecionada = etapa;
    },
    criarPedido(etapaId) {
      this.$router.push({ name: "autorizacoes.create", params: { etapa: etapaId } });
    },
    verPedidos() {
      this.$router.push({ name: "autorizacoes" });
    },
    verificarSeEtapaEstaDisp(etapa) {
      if (this.idsEtapasDisponivels.includes(etapa.id)) {
        this.etapaBloqueada = false;
      } else {
        this.etapaBloqueada = true;
      }
      if (this.idsEtapasPendentes.includes(etapa.id)) {
        this.etapaPendente = true;
      } else {
        this.etapaPendente = false;
      }
    },
    async verificarSeTemPedido(etapaId) {
      const response = await this.$services.autorizacoesService.verificarPedidosDeferidos(etapaId);

      if (response.data.aprovados?.length) {
        this.idsEtapasDisponivels.push(etapaId);
      }

      if (response.data.pendentes?.length) {
        this.idsEtapasPendentes.push(etapaId);
      }
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}

.custom-orange-alert .alert-text-black {
  color: black !important;
}

.events-card {
  margin-top: 20px;
}

.calendar-container-vertical {
  max-width: 100%;
  padding: 0;
}

.calendar-card-expanded {
  margin-bottom: 20px;
}

.expanded-date-picker {
  width: 100%;
}

.events-card-below {
  height: 100%;
  max-height: 300px;
  overflow-y: auto;
}

.event-list-expanded {
  max-height: 250px;
  overflow-y: auto;
}

.date-label {
  min-width: 30px;
  font-weight: bold;
}

.event-description {
  word-break: break-word;
}

.dialog-actions {
  padding: 16px;
  justify-content: flex-end;
}

/* Ajustes responsivos */
@media (max-width: 960px) {
  .calendar-container-vertical {
    flex-direction: column;
  }

  .calendar-card-expanded,
  .events-card-below {
    max-width: 100%;
  }

  .events-card-below {
    max-height: 250px;
  }
}
</style>
